import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
import Meta from 'vue-meta';
import VueCookies from 'vue-cookies';
import VueFragment from 'vue-fragment';
import { BootstrapVue } from 'bootstrap-vue';
import { gsap } from 'gsap';
import { ScrollToPlugin, InertiaPlugin, Draggable } from 'gsap/all';


import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import { initInterceptors } from '@/helpers/interceptor';

import App from './App.vue';

import i18n from './i18n';
import store from './store';
import router from './router';

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(InertiaPlugin);
gsap.registerPlugin(Draggable);

Vue.config.productionTip = false;

Vue.use(VueCompositionAPI);
Vue.use(Meta);
Vue.use(VueCookies);
Vue.use(VueFragment.Plugin);
Vue.use(BootstrapVue);

initInterceptors(store);

new Vue({
  store,
  router,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
